import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from '@aeCore/interceptors/auth.interceptor';
import { JwtModule } from '@auth0/angular-jwt';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { errorInterceptor } from '@aeCore/interceptors/error.interceptor';
import { loadingInterceptor } from '@aeCore/interceptors/loading.interceptor';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';

export function tokenGetter() {
  return sessionStorage.getItem('access_token');
}

export function moduleHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors(
      [
        authInterceptor,
        errorInterceptor,
        loadingInterceptor
      ]
    )),
    provideAnimations(),
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter,
          allowedDomains: ['example.com'],
          disallowedRoutes: [''],
        },
      }),
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: moduleHttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    { provide: NZ_I18N, useValue: en_US }
  ],
};
